export default __webpack_public_path__ + "static/004-b29f205be29e7e80c2e40dc01527a30a.png";